import { put, takeLatest } from "redux-saga/effects";
import _ from "lodash";

import { defaultReturn, makePayload, generateDefaultActions, requestSaga } from "../../utils/helpers";

export const initialState = {
  suppPricerResult: {},
  isCalculating: false
};

// SUPP_PRICER_CALCULATING
export const SUPP_PRICER_CALCULATING = generateDefaultActions("SUPP_PRICER_CALCULATING");
export const calculateSuppPricerCalculating = payload => makePayload(SUPP_PRICER_CALCULATING.value, payload);
function* calculateSuppPricerCalculatingSaga(payload) {
  yield put(SUPP_PRICER_CALCULATING.createSuccess(payload));
}

// CALCULATE_SUPP_PRICER
export const CALCULATE_SUPP_PRICER = generateDefaultActions("CALCULATE_SUPP_PRICER");
export const calculateSuppPricer = payload => makePayload(CALCULATE_SUPP_PRICER.value, payload);
function* calculateSuppPricerSaga(payload) {
  // const url = `/servermetrics/dealSuppPricer`;
  const url = "/dealSuppPricer";
  yield requestSaga(CALCULATE_SUPP_PRICER, url, "POST", payload);

  if (payload.callback) {
    payload.callback({ isCalculating: false });
  }
}

export function* suppPricerSaga() {
  yield takeLatest(CALCULATE_SUPP_PRICER.value, calculateSuppPricerSaga);
  yield takeLatest(SUPP_PRICER_CALCULATING.value, calculateSuppPricerCalculatingSaga);
}

export default function suppPricerReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SUPP_PRICER_CALCULATING.success:
      return defaultReturn(state, payload.isCalculating, "isCalculating");
    case CALCULATE_SUPP_PRICER.success:
      return defaultReturn(state, payload, "suppPricerResult");
    case CALCULATE_SUPP_PRICER.failure:
      return defaultReturn(state, false, "isCalculating");
    default:
      return state;
  }
}
